import { SxProps, Theme } from '@mui/material';

type TStyles = {
  notFound: SxProps<Theme>;
  notFoundContainer: SxProps<Theme>;
  notFoundH1: SxProps<Theme>;
  notFoundH2: SxProps<Theme>;
  notFoundH3: SxProps<Theme>;
  notFoundP: SxProps<Theme>;
  rootStyles: SxProps<Theme>;
};

const rootStyles: SxProps<Theme> = {
  m: 0,
  p: 0,
  textAlign: 'center',
  fontWeight: 'inherit',
};

export const styles: TStyles = {
  rootStyles,

  notFound: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },

  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  notFoundH1: (theme: Theme) => ({
    color: theme.palette.error.main,
    fontSize: { xs: '42px', sm: '56px', md: '72px' },
    ...rootStyles,
  }),

  notFoundH2: (theme: Theme) => ({
    color: theme.palette.common.black,
    fontSize: { xs: '16px', sm: '20px', md: '24px' },
    ...rootStyles,
  }),

  notFoundH3: {
    color: '#555',
    fontSize: { xs: '12px', sm: '16px', md: '18px' },
    ...rootStyles,
  },

  notFoundP: {
    color: '#777',
    fontSize: { xs: '10px', sm: '14px', md: '16px' },
    ...rootStyles,
  },
};
